import type { OrderContext } from '../types';

/**
 * The callback route (PaymentCallbackPage) is reached via a real browser
 * navigation — React state from PaymentPage doesn't survive that. This is
 * the one piece of session state that has to: the auth token and db_ptr
 * needed to call `/bookings/payment-status`. sessionStorage is scoped to
 * this tab and this checkout attempt, which is exactly the right lifetime —
 * it's cleared once the callback page reaches a terminal state.
 */
const STORAGE_KEY = 'nura_payment_pending_order_v1';

export function savePendingOrder(order: OrderContext): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(order));
  } catch {
    // Storage can be unavailable (private browsing, quota) — the callback
    // page degrades to its "couldn't verify automatically" state below.
  }
}

export function readPendingOrder(): OrderContext | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);

    return raw ? (JSON.parse(raw) as OrderContext) : null;
  } catch {
    return null;
  }
}

export function clearPendingOrder(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to do — worst case it's overwritten by the next checkout.
  }
}
